/**
 * timeline/constants.js
 * ─────────────────────────────────────────────────────────────────────────────
 * Single source of truth for every static value used across the Timeline view.
 */

// ── Pipeline sections — order and appearance ──────────────────────────────────
export const TIMELINE_SECTIONS = [
    {
        key: 'Backlog',
        label: 'Backlog / Upcoming',
        accentColor: '#c2c6d2',
        badgeBg: 'bg-slate-100',
        badgeText: 'text-slate-600',
        barBg: 'bg-slate-400',
        barTrack: 'bg-slate-200',
        borderColor: 'border-slate-300',
    },
    {
        key: 'In Progress',
        label: 'In Progress',
        accentColor: '#28b5fd',
        badgeBg: 'bg-blue-600',
        badgeText: 'text-white',
        barBg: 'bg-[#0284c7]',
        barTrack: 'bg-[#28b5fd]/30',
        borderColor: 'border-[#28b5fd]',
    },
    {
        key: 'Under Review',
        label: 'Under Review',
        accentColor: '#f59e0b',
        badgeBg: 'bg-amber-300/20',
        badgeText: 'text-amber-600',
        barBg: 'bg-amber-500',
        barTrack: 'bg-amber-300/30',
        borderColor: 'border-amber-400',
    },
    {
        key: 'Completed',
        label: 'Completed',
        accentColor: '#34d399',
        badgeBg: 'bg-emerald-50',
        badgeText: 'text-emerald-600',
        barBg: 'bg-emerald-500',
        barTrack: 'bg-emerald-400/25',
        borderColor: 'border-emerald-400',
    },
    {
        key: 'On Hold',
        label: 'On Hold',
        accentColor: '#fb923c',
        badgeBg: 'bg-orange-100',
        badgeText: 'text-orange-600',
        barBg: 'bg-orange-500',
        barTrack: 'bg-orange-300/30',
        borderColor: 'border-orange-400',
    },
    {
        key: 'Cancelled',
        label: 'Canceled',
        accentColor: '#f87171',
        badgeBg: 'bg-red-100',
        badgeText: 'text-red-600',
        barBg: 'bg-red-500',
        barTrack: 'bg-red-300/25',
        borderColor: 'border-red-400',
    },
];

// ── View modes ────────────────────────────────────────────────────────────────
export const VIEW_MODES = [
    { key: 'day', label: 'Day' },
    { key: 'week', label: 'Week' },
    { key: 'month', label: 'Month' },
    { key: 'quarter', label: 'Quarter' },
];

// ── Priority badge styles (reused from kanban palette for consistency) ─────────
export const PRIORITY_BADGE = {
    Critical: { bg: 'bg-[#ffdad6]', text: 'text-[#93000a]', dot: 'bg-[#93000a]' },
    High: { bg: 'bg-red-50', text: 'text-red-600', dot: 'bg-red-500' },
    Medium: { bg: 'bg-[#c9e6ff]', text: 'text-[#004c6e]', dot: 'bg-[#006591]' },
    Low: { bg: 'bg-[#e7e8e9]', text: 'text-[#424750]', dot: 'bg-slate-400' },
};

// ── Fixed widths ──────────────────────────────────────────────────────────────
// Width (px) of the left sidebar panel listing task names + pipeline sections
export const SIDEBAR_WIDTH = 260;

// Width (px) of each granularity column in the Gantt grid
export const CELL_WIDTH = {
    day: 72,       // was 48
    week: 130,     // was 90
    month: 140,    // was 90 — wide enough that a 160px min-bar spans less than 2 columns
    quarter: 120,  // was 80
};

// Row height (px) for each Gantt task row
export const ROW_HEIGHT = 48;

// Section header row height (px)
export const SECTION_ROW_HEIGHT = 36;
